// Mock data for aKonyhád! restaurant website

export const restaurantInfo = {
  name: "aKonyhád!",
  tagline: "Az ízek otthona Miskolcon",
  description: "Friss, magyaros és modern fogások – 4.9 csillagos élmény",
  rating: 4.9,
  reviewCount: 189,
  priceRange: "2000–4000 Ft",
  phone: "+36 70 555 7794",
  address: "3525 Miskolc, Kis-Hunyad u. 52",
  openingDay: "Hétfő - Péntek: 11:00 - 17:00",
  facebook: "https://facebook.com/akonyhadmiskolc"
};

export const services = [
  {
    icon: "star",
    title: "4.9 értékelés",
    description: "189 vélemény alapján"
  },
  {
    icon: "home",
    title: "Helyben fogyasztás",
    description: "Meghitt éttermi élmény"
  },
  {
    icon: "truck",
    title: "Érintkezés nélküli kiszállítás",
    description: "Biztonságos házhoz szállítás"
  },
  {
    icon: "chef-hat",
    title: "Magyaros és modern ízek",
    description: "Hagyomány találkozik az innovációval"
  }
];

export const menuCategories = [
  {
    name: "Levesek",
    description: "Házi készítésű, forró levesek",
    items: [
      { name: "Gulyásleves", price: "2200 Ft" },
      { name: "Húsleves cérnametélttel", price: "2000 Ft" },
      { name: "Bableves", price: "2100 Ft" }
    ]
  },
  {
    name: "Főételek",
    description: "Válogatott magyar specialitások",
    items: [
      { name: "Pörkölt nokedlivel", price: "3800 Ft" },
      { name: "Rántott hús burgonyával", price: "3500 Ft" },
      { name: "Töltött káposzta", price: "3600 Ft" },
      { name: "Paprikás csirke galuskával", price: "3700 Ft" }
    ]
  },
  {
    name: "Desszertek",
    description: "Házias édes finomságok",
    items: [
      { name: "Somlói galuska", price: "1800 Ft" },
      { name: "Túrós rétes", price: "1600 Ft" },
      { name: "Palacsinta", price: "1500 Ft" }
    ]
  },
  {
    name: "Napi ajánlat",
    description: "Friss, naponta változó menü",
    items: [
      { name: "Hétfő menü", price: "3200 Ft" },
      { name: "Kedd menü", price: "3200 Ft" },
      { name: "Szerda menü", price: "3200 Ft" }
    ]
  }
];

export const reviews = [
  {
    name: "Nagy Éva",
    rating: 5,
    date: "2025-01-15",
    text: "Fantasztikus ételek, hatalmas adagok! A gulyásleves olyan volt, mint amit nagymamám főzött. Mindenképpen visszajövünk!"
  },
  {
    name: "Kovács Péter",
    rating: 5,
    date: "2025-01-10",
    text: "Kiváló ár-érték arány, kedves kiszolgálás. A pörkölt egyszerűen isteni volt. Az egyik legjobb hely Miskolcon!"
  },
  {
    name: "Szabó Ildikó",
    rating: 5,
    date: "2025-01-08",
    text: "Minden alkalommal elragadtat a minőség és a frissesség. A házi rétes csodálatos! Csak ajánlani tudom!"
  },
  {
    name: "Tóth János",
    rating: 5,
    date: "2025-01-05",
    text: "Autentikus magyar ízek modern köntösben. A kiszállítás gyors volt, az étel pedig még melegen érkezett. Tökéletes!"
  }
];

export const aboutText = {
  title: "Rólunk",
  paragraphs: [
    "2022-ben a honvágy, a kreativitás és valami hiánypótló hely megteremtése hozott minket haza Nyugat-Európából, ekkor nyitottuk meg éttermünket Miskolcon. Családi vállalkozásként egy olyan helyet álmodtunk meg, ahol a minőség, a vendégszeretet és a megfizethető árak kéz a kézben járnak.",
    "Magyar és nemzetközi konyhát viszünk, modern bisztró stílusban. Fontos számunkra, hogy minden étel friss alapanyagból, odafigyeléssel készüljön, miközben a klasszikus kedvencek mellett izgalmas, új ízeket is kínálunk.",
    "Nem célunk újra feltalálni a gasztronómiát, egyszerűen csak jól főzni."
  ]
};

export const galleryImages = [
  "https://customer-assets.emergentagent.com/job_2e08abfd-9d61-4b02-9272-bb8dc030b0a2/artifacts/j6oqimkk_IMG_5131.jpeg",
  "https://customer-assets.emergentagent.com/job_2e08abfd-9d61-4b02-9272-bb8dc030b0a2/artifacts/g34gmmwn_IMG_5137.jpeg",
  "https://customer-assets.emergentagent.com/job_2e08abfd-9d61-4b02-9272-bb8dc030b0a2/artifacts/miwp1nbs_IMG_5155.jpeg",
  "https://customer-assets.emergentagent.com/job_2e08abfd-9d61-4b02-9272-bb8dc030b0a2/artifacts/une5dolx_IMG_7286.jpeg",
  "https://customer-assets.emergentagent.com/job_2e08abfd-9d61-4b02-9272-bb8dc030b0a2/artifacts/xcz4t09t_IMG_8076.jpeg",
  "https://customer-assets.emergentagent.com/job_2e08abfd-9d61-4b02-9272-bb8dc030b0a2/artifacts/tayh34i4_IMG_1636.jpeg"
];
